import FullBleedHero from './FullBleedHero';

export default FullBleedHero;
